module.exports = __webpack_public_path__ + "img/presse-olca-sm.6a005057.jpg";